import React from 'react'
import PropTypes from 'prop-types'
import { openURIInApp, launchExtAppInApp } from '../../utils/URLSchemeHelper'
import moment from 'moment'

// image URLs will be inlined directly in JSX using `new URL(..., import.meta.url).href`
const EntertainmentList = ({ osName }) => {
  // 期間限定バナーの判定
  const isLimitedTimeBannerOpen = () => {
    moment.tz.setDefault('Asia/Tokyo')
    // ：2020/12/29（火）01:30〜（28日営業日の終電後）

    return (
      moment().isAfter(moment('2021-03-08 10:00:00')) &&
      moment().isBefore(moment('2021-03-23 10:00:00'))
    )
  }

  moment.tz.setDefault('Asia/Tokyo')
  return (
    <div className="d-Entertainment">
      <h1 className="d-Entertainment-title">エンタメ</h1>
      <p className="d-Entertainment-caption">相鉄についてもっと知っていただくためのさまざまなコンテンツを紹介します。</p>
      <p className="d-Entertainment-note">※外部ブラウザアプリで表示します</p>

      <ul className="d-Entertainment-bannerList">

        {isLimitedTimeBannerOpen() &&
        <li className="d-Entertainment-bannerItem">
          <a onClick={() => openURIInApp('https://www.sounyan-event.com/', 'ENTERTAINMENT', 'SOUNYAN_EVENT')}>
            <img src={new URL('../../assets/images/entertainment_btn_2102greeting.png', import.meta.url).href} className="d-Entertainment-bannerImg" />
          </a>
          <p className="d-Entertainment-bannerText">４月１０日（土）に開催する「そうにゃんグリーティングイベント」へ３６０組をご招待します。上記バナーをクリックいただき、リンク先のお申込みフォームにて募集要項をご確認の上、お申し込みください。</p>
        </li>}

          <li className="d-Entertainment-bannerItem">
            <a onClick={() => openURIInApp('https://x.com/sotetsu_group', 'ENTERTAINMENT', 'SOTETSU_GROUP_TWITTER')}>
              <img src={new URL('../../assets/images/entertainment_btn_sotetsu_x.png', import.meta.url).href} className="d-Entertainment-bannerImg" />
            </a>
            <p className="d-Entertainment-bannerText">相鉄グループの公式アカウントです。<br />
              相模鉄道・相鉄バス・商業施設など相鉄グループ各社の最新情報やトピックス、沿線の情報などをご紹介します。</p>
          </li>
          <li className="d-Entertainment-bannerItem">
            <a onClick={() => openURIInApp('https://www.sotetsu.co.jp/sotetsu-style-app/', 'ENTERTAINMENT', 'SOTETSU_STYLE_APP')}>
              <img src={new URL('../../assets/images/entertainment_btn_sotetsustyleapp_202308.jpg', import.meta.url).href} className="d-Entertainment-bannerImg" />
            </a>
            <p className="d-Entertainment-bannerText">「相鉄Styleアプリ」は相鉄線沿線のニュースやイベント情報をお届けしています。<br />記事閲覧のほかに、相鉄ポイント会員証や相鉄線・相鉄バスの運⾏状況や乗り継ぎをカンタン検索できる相鉄Naviなど豊富なコンテンツで相鉄線沿線での快適な暮らしをサポートします。</p>
          </li>
          <li className="d-Entertainment-bannerItem">
            <a onClick={() => openURIInApp('https://www.youtube.com/@%E7%9B%B8%E6%A8%A1%E9%89%84%E9%81%93%E6%A0%AA%E5%BC%8F%E4%BC%9A%E7%A4%BE', 'ENTERTAINMENT', 'SOTETSU_YOUTUBE')}>
                <img src={new URL('../../assets/images/entertainment_btn_youtube.png', import.meta.url).href} className="d-Entertainment-bannerImg" />
            </a>
            <p className="d-Entertainment-bannerText">相模鉄道公式Youtubeチャンネルです。<br />相模鉄道キャラクターそうにゃんや沿線情報など様々な動画を配信中！</p>
          </li>
          <li className="d-Entertainment-bannerItem">
            <a onClick={() => openURIInApp('https://www.instagram.com/sagami_railway/', 'ENTERTAINMENT', 'SOTETSU_INSTAGRAM')}>
              <img src={new URL('../../assets/images/entertainment_btn_soutetsuinstagram.png', import.meta.url).href} className="d-Entertainment-bannerImg" />
            </a>
            <p className="d-Entertainment-bannerText">相模鉄道公式インスタグラム「もっと相鉄線」です。<br/>相鉄線沿いの何気ない日常の中で見つけた魅力を発信しています。相鉄のことをもっと好きになってもらうためのアカウントです。</p>
          </li>
          <li className="d-Entertainment-bannerItem">
            <a onClick={() => openURIInApp('https://www.sounyan.jp/', 'ENTERTAINMENT', 'SOTETSU_SOUNYAN')}>
              <img src={new URL('../../assets/images/entertainment_btn_sounyan.png', import.meta.url).href} className="d-Entertainment-bannerImg" />
            </a>
            <p className="d-Entertainment-bannerText">相模鉄道キャラクター「そうにゃん」のオフィシャルサイトです。「そうにゃんブログ」や出演イベント情報、季節ごとの壁紙の配信、「そうにゃんグッズ」や鉄道グッズの紹介などをしています。</p>
          </li>
          <li className="d-Entertainment-bannerItem">
            <a onClick={() => openURIInApp('https://www.sotetsu.co.jp/kawaraban/default.htm', 'ENTERTAINMENT', 'KAWARABAN')}>
              <img src={new URL('../../assets/images/entertainment_btn_kawaraban.png', import.meta.url).href} className="d-Entertainment-bannerImg" />
            </a>
            <p className="d-Entertainment-bannerText">1976年３月から発行している文庫本サイズの広報誌のデジタルブックです。相鉄線をご乗車いただいている間(横浜駅～海老名駅間・特急利用で約26分)に読み切れるボリュームが好評で、スポーツや雑学などさまざまなテーマを毎号特集し、相鉄線をご利用いただいているお客様や沿線の皆さまに親しまれています。</p>
          </li>

          {moment().isBefore(moment('2021-12-20 13:00:00')) && 
            <li className="d-Entertainment-bannerItem">
              <a onClick={() => {
                launchExtAppInApp('package=jp.co.sotetsu.sotetsulinegameapplication&scheme=sotetsulinegame-app&id=1441282182', 'ENTERTAINMENT', 'SOTETSU_GAME')
              }}>
                <img src={new URL('../../assets/images/entertainment_btn_sotetsu.png', import.meta.url).href} className="d-Entertainment-bannerImg" />
              </a>
              <p className="d-Entertainment-bannerText">あの人気鉄道経営ゲーム「Ａ列車で行こう」と相模鉄道とのコラボレーション企画。スマホゲームアプリ「相鉄線で行こう」を配信しております。相鉄線沿線の街並みや魅力に触れつつ、相模鉄道キャラクターのそうにゃんとともに、ゴールである横浜駅を目指そう！</p>
            </li>
          }
        </ul>
      </div>
    )
}

EntertainmentList.propTypes = {
  osName: PropTypes.string.isRequired,}

export default EntertainmentList